module.exports = function getResource(label, vars = []) {
    let resources = {
        closed: 'Closed',
        findASephora: 'Find a Sephora',
        showMoreLocations: 'Show more locations',
        happeningAtSephora: 'Happening at Sephora',
        freeServicesAtStore: 'Free services, brand launches, classes & more—see what’s going on at your store today.',
        seeWhatsHappening: 'See What’s Happening',
        map: 'Map',
        list: 'List',
        noStoreNear: `We were not able to find a store near “${vars[0]}”.`,
        pleaseTryDifferentLocation: 'Please try a different location.',
        seeCompleteStoreList: 'See complete store list',
        sephora: 'Sephora',
        openUntil: 'Open until',
        storeDetails: 'Store details'
    };
    return resources[label];
};
